module.exports = __webpack_public_path__ + "img/w-icon-fire.07514e40.png";